import {
  cloneDeep
} from "lodash";
// TODO: business reducer
const defaultState = {
  name: '',
  userId: '',
  email: '',
  locations: []
};

const business = (state = defaultState, action) => {
  Object.freeze(state);
  let newState = cloneDeep(state);
  let { locations } = newState;
  const {
    locationIdx, 
    key, 
    value,
    phoneIdx,
    userId
  } = action;
  switch (action.type) {
    case 'RESET_BUSINESS':
      return Object.assign({}, defaultState);
    case 'SET_BUSINESS':
      return {
        ...action.business
      };
    case 'SET_BUSINESS_USERID':
      return {
        ...newState,
        userId
      };
    case 'UPDATE_BUSINESS':
      return {
        ...newState,
        [key]: value
      };
    case 'ADD_BUSINESS_LOCATION':
      locations.push({
        id: 0,
        alias: '',
        address: '',
        hours: 'Monday: 10:00 AM - 10:00 PM|Tuesday: 10:00 AM - 10:00 PM|Wednesday: 10:00 AM - 10:00 PM|Thursday: 10:00 AM - 10:00 PM|Friday: 10:00 AM - 10:00 PM|Saturday: 10:00 AM - 10:00 PM|Sunday: 10:00 AM - 10:00 PM',
        phoneNumbers: [{
          name: '',
          number: ''
        }]
      });
      return {
        ...newState,
        locations
      };
    case 'ADD_BUSINESS_PHONENUMBER':
      locations[locationIdx].phoneNumbers.push({
        id: 0,
        name: '',
        number: ''
      });
      return {
        ...newState,
        locations
      };
    case 'UPDATE_BUSINESS_LOCATION':
      locations[locationIdx][key] = value
      return {
        ...newState,
        locations
      }
    case 'UPDATE_BUSINESS_PHONENUMBER':
      locations[locationIdx].phoneNumbers[phoneIdx][key] = value;
      return {
        ...newState,
        locations
      };
    case 'REMOVE_BUSINESS_LOCATION':
      locations.splice(locationIdx, 1);
      return {
        ...newState,
        locations
      }
    case 'REMOVE_BUSINESS_PHONENUMBER':
      locations[locationIdx].phoneNumbers.splice(phoneIdx, 1);
      return {
        ...newState,
        locations
      }
    default:
      return state;
  }
};

export default business;